import React from 'react';
import {injectIntl} from 'react-intl';
import Icon from "@Components/Icon";
import citiesList from "@Config/fr/citiesLinkList.json"

function LinkList({}) {
    let defaultCitiesLinkList = {};
    const arrayCities = Object.keys(citiesList);
    arrayCities.forEach( (key, value) => {
        if (defaultCitiesLinkList.hasOwnProperty(citiesList[key].location)) {
            defaultCitiesLinkList[citiesList[key].location].count = 0;
        } else {
            defaultCitiesLinkList[citiesList[key].location] = {
                "count": 0,
                "url": citiesList[key].url
            }
        }
    })

    let citiesLinkList = Object.keys(defaultCitiesLinkList).sort().reduce(
            (obj, key) => {
                obj[key] = defaultCitiesLinkList[key];
                return obj;
            },
            {}
        );

  return (
    <>
      <ul className="link-list link-list--categories link-list--featured mt-none">
        {Object.entries(citiesLinkList).map(([city, count]) =>
          <li key={city} className="link-list__item">
            <a href={`/nos-agences${citiesLinkList[city].url}`} className="link-list__link">agence intérim {city}
              <Icon icon="chevron-right" />
            </a>
          </li>
        )}
      </ul>
    </>
  );
}

export default injectIntl(LinkList);
